export default {
    products(state) {
        return state.products;
    },

    cart(state) {
        return state.cart;
    },

    buyerData(state) {
        return state.buyerData;
    },

    deliveryToOtherAddress(state) {
        return state.deliveryToOtherAddress;
    },

    deliveryAddress(state) {
        return state.deliveryAddress;
    },

    deliveryToPhoneAndEmail(state) {
        return state.deliveryToPhoneAndEmail;
    },

    paymentType(state) {
        return state.paymentType;
    },

    deliveryAdditionalInfo(state) {
        return state.deliveryAdditionalInfo;
    },

    buyerDataErrors(state) {
        return state.buyerDataErrors;
    },

    deliveryDataErrors(state) {
        return state.deliveryDataErrors;
    },

    prisonerData(state) {
        return state.prisonerData;
    },

    prisonerDataErrors(state) {
        return state.prisonerDataErrors;
    },

    deliveryToPrison(state) {
        return state.deliveryToPrison;
    },

    location(state) {
        return state.location;
    },

    locations(state) {
        return state.locations;
    },

    order(state) {
        return state.order;
    },

    deliveryToOtherEmailAndPhone(state) {
        return state.deliveryToOtherEmailAndPhone;
    },

    edeliveryAddress(state) {
        return state.edeliveryAddress;
    },

    edeliveryDataErrors(state) {
        return state.edeliveryDataErrors;
    },

    cartError: state => state.cartError,

    invoiceDataErrors: state => state.invoiceDataErrors,

    currentOptionsStage: state => state.currentOptionsStage,

    invoiceData: state => state.invoiceData,

    letterOptions: state => state.letterOptions,
}